export const determineCarrierName = (
  shipowner?: {
    name?: null | string;
    parentShipownerGroup?: { name?: null | string } | null;
  } | null,
) => {
  return shipowner?.parentShipownerGroup?.name ?? shipowner?.name;
};
